import React, { useContext, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { SubscriberAuthContext } from 'services/auth_subscriber';

const CheckRegistrationRoute = ({ children }) => {
    const { skipRegistration, isCompany, isApplicant } = useContext(SubscriberAuthContext);

    if (!skipRegistration && !isCompany && !isApplicant) {
        return <Navigate to="/registration/" replace />;
    }

    return children;
};

export default CheckRegistrationRoute;